import merge from 'lodash/merge';

import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';

export const axios = createAxiosInstance(env.libraryIntelligenceApiUrl, {
  camelizeKeys: true,
});

/**
 * Get visual features string from image data
 *
 * Expects a base64 encoding for a jpg image (excluding MIME type).
 * Uses a HTML form content-type rather than JSON, per intelligence's endpoint.
 */
export async function vectoriseV2({ imageData: img }, axiosConfig = {}) {
  return axios.post(
    `/vectorise_v2`,
    { img },
    merge({ headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }, axiosConfig),
  );
}

export async function detectTextLanguage({ texts }, axiosConfig = {}) {
  return axios.post(`/detect_language`, { texts }, axiosConfig);
}

export async function translateTextLanguage({ texts }, axiosConfig = {}) {
  return axios.post(`/translate_language`, { texts }, axiosConfig);
}

/**
 * @param {{ brandId: any, mediaId: any, numberOfMediaToGenerate?: number, referenceUrl?: string | null, parentAlternativeId?: number | null, mode?: string }} params
 * @param {import('axios').AxiosRequestConfig} [axiosConfig]
 */
export async function generateAiAlternatives(
  {
    brandId,
    mediaId,
    numberOfMediaToGenerate = 8,
    referenceUrl,
    parentAlternativeId = null,
    mode = 'creative',
  },
  axiosConfig = {},
) {
  return axios.post(
    `/ai_alternative_media`,
    {
      brandId,
      mediaId,
      numberOfMediaToGenerate,
      mode,
      ...(referenceUrl && { referenceUrl }),
      ...(parentAlternativeId && { parentId: parentAlternativeId }),
    },
    axiosConfig,
  );
}

export async function generateAiAlternativeAds(
  { brandId, adPlatform, sourceAdId, sourceCampaignId, sourceAdAccountId, thumbnailUrl },
  axiosConfig = {},
) {
  return axios.post(
    `/ai_alternative_ads`,
    {
      brandId,
      adPlatform,
      sourceAdId,
      sourceCampaignId,
      sourceAdAccountId,
      thumbnailUrl,
      mode: 'strict',
    },
    axiosConfig,
  );
}

/**
 * @param {Object} params
 * @param {number} params.brandId
 * @param {string} params.instruction
 * @param {string[]} [params.imageUrls]
 * @param {string} [params.sessionId]
 * @param {number} [params.replayFromTurn]
 * @param {import('axios').AxiosRequestConfig} [axiosConfig]
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export async function editAiImage(
  { brandId, instruction, imageUrls, sessionId, replayFromTurn },
  axiosConfig = {},
) {
  return axios.post(
    `/ai_image_edit`,
    {
      brandId,
      instruction,
      imageUrls,
      ...(sessionId && { sessionId }),
      ...(replayFromTurn && { replayFromTurn }),
    },
    axiosConfig,
  );
}
